export const usmle1PhysioModule = {
  id: "physio",
  title: "Physiology",
  sections: [
    {
      type: "text",
      content:
        "Cardiac output = HR x SV. MAP roughly equals CO x SVR.",
    },
    {
      type: "question",
      text: "Which formula best estimates mean arterial pressure?",
      options: ["CO x SVR", "HR x SV", "SV/EDV", "SVR/CO"],
      correct: 0,
      explanation: "MAP is approximately CO x SVR.",
    },
  ],
};
